// Export the new CookieConsent component (designed with 3 buttons + preferences modal)
export { default } from './CookieConsent';
export { default as CookieSettingsLink } from './CookieSettingsLink';
export { default as PreferencesModal } from './PreferencesModal';
